// Generated by CoffeeScript 1.12.6
(function() {
  var ceri;

  ceri = require("ceri/lib/wrapper");

  module.exports = ceri({
    mixins: [require("ceri/lib/props"), require("ceri/lib/style"), require("ceri/lib/open"), require("ceri/lib/overlay")],
    props: {
      opacity: {
        type: Number,
        "default": 0.5
      },
      keepOpen: {
        type: Boolean
      },
      zIndex: {
        type: Number,
        "default": 1500
      },
      bottomSheet: {
        type: Boolean
      },
      attach: {
        type: String
      }
    },
    events: {
      click: {
        target: {
          active: function() {
            return this.target && !this.openingOrOpen;
          },
          notPrevented: true,
          prevent: true,
          cbs: "show",
          destroy: true
        }
      }
    },
    computed: {
      target: function() {
        if (this.attach) {
          return document.querySelector(this.attach);
        } else if (this.attach != null) {
          if (this.__placeholder.previousElementSibling) {
            return this.__placeholder.previousElementSibling;
          } else {
            return this.__parentElement;
          }
        }
        return null;
      }
    },
    data: function() {
      return {
        onBody: true
      };
    },
    overlay: {
      zIndex: "zIndex",
      active: "openingOrOpen",
      animate: "toggleAnimate",
      keepOpen: "keepOpen",
      delay: true,
      onClose: "hide",
      onOpen: function(zIndex) {
        return this.style.zIndex = zIndex + 1;
      }
    },
    initStyle: {
      position: "fixed",
      left: 0,
      right: 0,
      display: "block"
    },
    methods: {
      enter: function(o) {
        if (this.bottomSheet) {
          o.style = {
            bottom: [-100, 0, "%"],
            opacity: [0, 1]
          };
        } else {
          o.style = {
            top: [4, 10, "%"],
            opacity: [0, 1],
            scaleX: [0.7, 1]
          };
        }
        return this.$animate(o);
      },
      leave: function(o) {
        o.duration = 200;
        if (this.bottomSheet) {
          o.style = {
            bottom: [0, -100, "%"],
            opacity: [1, 0]
          };
        } else {
          o.style = {
            top: [10, 4, "%"],
            opacity: [1, 0],
            scaleX: [1, 0.7]
          };
        }
        return this.$animate(o);
      }
    }
  });

}).call(this);



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri-modal/modal.js
// module id = 36
// module chunks = 1